export default __webpack_public_path__ + "static/media/2.930be064.png";